import React, { Dispatch, Fragment, SetStateAction, useState } from 'react';
import RemoveVendorModal from 'components/modals/remove-vendor-modal';
import './styles.scss';
import useInventoryStoreContext from 'contexts/inventory-store.context/context';
import EditStoreItemForm from './edit-store-item-form';

const UpdateStoreDetails = ({
  vendorIngredientIdsToDelete,
  setVendorIngredientIdsToDelete
}: {
  vendorIngredientIdsToDelete: string[];
  setVendorIngredientIdsToDelete: Dispatch<SetStateAction<string[]>>;
}) => {
  const [showRemoveModal, setShowRemoveModal] = useState(false);
  const { storeItemsToEdit, setStoreItemsToEdit } = useInventoryStoreContext();
  const [showStoreDetails, setShowStoreDetails] = useState(
    Array.from({ length: storeItemsToEdit.length }, () => false)
  );

  const toggleStoreDetails = (index: number) => {
    const updatedShowStoreDetails = [...showStoreDetails];
    updatedShowStoreDetails[index] = !updatedShowStoreDetails[index];
    setShowStoreDetails(updatedShowStoreDetails);
  };

  return (
    <Fragment>
      <div className='ml-2 md:ml-8 request'>
        <div className='bg-white w-full max-w-[670px] h-auto rounded-md pt-2'>
          <h4 className='font-semibold text-[20px] -ml-8 mt-[-30px]'>Update Selected Items</h4>
          <p className='mt-2 -ml-8 text-xs text-gray-9 '>Change item details</p>
          <div className='mt-6'>
            {storeItemsToEdit &&
              storeItemsToEdit.map((item, index) => (
                <div key={index} className='mt-4 w-full edit_form'>
                  <div className='bg-[#F7F7F7E5] border-b border-[#EAEBEB] py-3 ml-[-60px] mr-[-28px] flex justify-between'>
                    <p className='text-[16px]  font-medium pl-[28px]'>{item.name}</p>
                    <div
                      className='bg-white border border-[#EAEBEB] rounded-[100px] px-4 py-2 text-xs font-medium text-[#5E6164] cursor-pointer mr-[28px]'
                      onClick={() => toggleStoreDetails(index)}>
                      {showStoreDetails[index] ? 'Hide' : 'Show'}
                    </div>
                  </div>
                  <div>
                    {showStoreDetails[index] && (
                      <EditStoreItemForm
                        setStoreItem={(newItem) => {
                          setStoreItemsToEdit(
                            storeItemsToEdit.map((req, i) => {
                              if (i === index) return newItem;
                              return req;
                            })
                          );
                        }}
                        vendorIngredientIdsToDelete={vendorIngredientIdsToDelete}
                        setVendorIngredientIdsToDelete={setVendorIngredientIdsToDelete}
                        storeItem={storeItemsToEdit[index]}
                        handleDelete={() => {
                          setStoreItemsToEdit(storeItemsToEdit.filter((_, i) => i !== index));
                        }}
                        index={index}
                      />
                    )}
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
      <RemoveVendorModal
        isOpen={showRemoveModal}
        onRequestClose={() => setShowRemoveModal(false)}
      />
    </Fragment>
  );
};

export default UpdateStoreDetails;
